import { render, staticRenderFns } from "./smsSystem.vue?vue&type=template&id=381be612&scoped=true&"
import script from "./smsSystem.vue?vue&type=script&lang=js&"
export * from "./smsSystem.vue?vue&type=script&lang=js&"
import style0 from "./smsSystem.vue?vue&type=style&index=0&id=381be612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381be612",
  null
  
)

export default component.exports